import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { FilterButtons } from '../FilterButtons';
function getCountGamesByPlatformType(games, element) {
    const releaseCounts = games.reduce((counts, item) => {
        if (!element.querySelector(`[data-sku="${item.sku}"]`)) {
            return counts;
        }
        const releaseAttribute = item.attributes.find((attr) => attr.name.toLowerCase() === 'platform');
        if (releaseAttribute) {
            releaseAttribute.values.forEach(({ value }) => {
                counts[value] = (counts[value] || 0) + 1;
            });
        }
        return counts;
    }, {});
    return releaseCounts;
}
function generatePlatformButtons(goods, onSelectPlatform, element) {
    const uniquePlatforms = new Set();
    goods.forEach((game) => {
        const platformAttribute = game.attributes.find((attr) => attr.name.toLowerCase() === 'platform');
        if (platformAttribute) {
            platformAttribute.values.forEach(({ value }) => {
                uniquePlatforms.add(value.toLowerCase());
            });
        }
    });
    const platformCounts = getCountGamesByPlatformType(goods, element);
    return [
        {
            name: 'All',
            value: '',
            onClick: () => {
                onSelectPlatform('');
            },
        },
        ...Array.from(uniquePlatforms).map((platform) => ({
            name: `${platform.toUpperCase()} - ${platformCounts[platform] || 0}`,
            value: platform,
            onClick: () => {
                onSelectPlatform(platform.toLocaleLowerCase());
            },
        }))
    ];
}
export const PlatformFilter = ({ selectedPlatformType, onSelectPlatform, state, element, }) => {
    const [goods, setGoods] = useState([]);
    const platformButtons = generatePlatformButtons(goods, onSelectPlatform, element);
    useEffect(() => {
        setGoods(state.storeState.units.items);
    }, []);
    return (_jsx(FilterButtons, { selectedValue: selectedPlatformType, buttons: platformButtons, name: "By Platform" }));
};
